var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomizationButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8769_11432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 17.375V1.625C1.875 1.42609 1.95402 1.23532 2.09467 1.09467C2.23532 0.954018 2.42609 0.875 2.625 0.875C2.82391 0.875 3.01468 0.954018 3.15533 1.09467C3.29598 1.23532 3.375 1.42609 3.375 1.625V17.375C3.375 17.5739 3.29598 17.7647 3.15533 17.9053C3.01468 18.046 2.82391 18.125 2.625 18.125C2.42609 18.125 2.23532 18.046 2.09467 17.9053C1.95402 17.7647 1.875 17.5739 1.875 17.375Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 8V4.25C4.875 3.83579 4.53921 3.5 4.125 3.5H1.125C0.710786 3.5 0.375 3.83579 0.375 4.25V8C0.375 8.41421 0.710786 8.75 1.125 8.75H4.125C4.53921 8.75 4.875 8.41421 4.875 8Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.375V1.625C8.25 1.42609 8.32902 1.23532 8.46967 1.09467C8.61032 0.954018 8.80109 0.875 9 0.875C9.19891 0.875 9.38968 0.954018 9.53033 1.09467C9.67098 1.23532 9.75 1.42609 9.75 1.625V17.375C9.75 17.5739 9.67098 17.7647 9.53033 17.9053C9.38968 18.046 9.19891 18.125 9 18.125C8.80109 18.125 8.61032 18.046 8.46967 17.9053C8.32902 17.7647 8.25 17.5739 8.25 17.375Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 17.375V1.625C14.625 1.42609 14.704 1.23532 14.8447 1.09467C14.9853 0.954018 15.1761 0.875 15.375 0.875C15.5739 0.875 15.7647 0.954018 15.9053 1.09467C16.046 1.23532 16.125 1.42609 16.125 1.625V17.375C16.125 17.5739 16.046 17.7647 15.9053 17.9053C15.7647 18.046 15.5739 18.125 15.375 18.125C15.1761 18.125 14.9853 18.046 14.8447 17.9053C14.704 17.7647 14.625 17.5739 14.625 17.375Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 8V4.25C17.625 3.83579 17.2892 3.5 16.875 3.5H13.875C13.4608 3.5 13.125 3.83579 13.125 4.25V8C13.125 8.41421 13.4608 8.75 13.875 8.75H16.875C17.2892 8.75 17.625 8.41421 17.625 8Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.75V11C11.25 10.5858 10.9142 10.25 10.5 10.25H7.5C7.08579 10.25 6.75 10.5858 6.75 11V14.75C6.75 15.1642 7.08579 15.5 7.5 15.5H10.5C10.9142 15.5 11.25 15.1642 11.25 14.75Z",
    fill: "#F6F6F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8769_11432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(0 1 -1 0 18 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizationButton);
export default __webpack_public_path__ + "static/media/customizationButton.762f57a36369882e1daf7b9afdaf247a.svg";
export { ForwardRef as ReactComponent };